






































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Emit, Prop, Watch } from 'vue-property-decorator'
import MapView from '@/views/mapview/Map.vue'
import LeafletMapView from '@/views/mapview/LeafletMap.vue'
import Node from '@/models/Node'
import Vector2 from '@/models/Vector2'
import ImageInput from '@/components/ImageInput.vue'
import Project from '@/models/Project'
import BTextareaLimited from '@/components/input_limited/BTextareaLimited.vue';
import BFormInputLimited from '@/components/input_limited/BFormInputLimited.vue';
import project from '@/store/modules/project';
import { mapGetters } from 'vuex';
import { SendPacket } from '../../../networking/SendPacket'
import { PacketType } from '../../../models/Packet'
import { MapNodeCreateRequest, MapNodeEditRequest, MapNodeDestroy, ChangeMapDataPacket } from '@/models/packets/MapNode'
import deepEqual from 'deep-equal'

@Component({
	components: {
		MapView,
		ImageInput,
		LeafletMapView,
		BTextareaLimited,
		BFormInputLimited
	},
	watch: {
        project: function(cur : Project, old: Project)
        {
            let _this = this as EditMapModalContent
            _this.readData();
        },
		"projectData.type": function (cur:string, old:string){
			let tg = this as any;
			if (!tg.hasLoaded)
			{
				return;
			}

			let data = tg.projectData;
			if (data.background_image)
			{
				delete data.background_image;
			}
			if (data.coords)
			{
				delete data.coords;
			}
			if (data.caption)
			{
				delete data.caption;
			}

			// Clear it if we're not moving between default/image
			if (!((old == 'default' && cur == 'image') || (old == 'image' && cur == 'default')))
			{
				tg.mapNodes.length = 0
				this.$set(this, 'selectedMapPin', null);
			}

			if (cur == 'image' && old != 'image')
			{
				this.$set(data, 'background_image', '')
			}
			if (cur == 'map')
			{
				this.$set(data, 'coords', { latitude : 0, longitude : 0, zoom_level : 1 })
			}
			if (cur != 'none')
			{
				this.$set(data, 'caption', '');
			}
			this.$set(this, 'projectData', data);
		}
    },
    computed: 
	{
		...mapGetters([
			'mapToTimeline',
			'timelines',
			'mapNodes',
			'checkTimelineAdmin',
			'checkTimelineWrite',
			'checkTimelineRead',
			'nodes'
		])
	}
})
export default class EditMapModalContent extends Vue {
    @Prop(Object) readonly modal! : Object;
    @Prop(Project) readonly project! : Project;
	hasLoaded = false;

    get projectNodes()
    {
        return (this as any).mapNodes as Map<number, Node>;
    }

	loading = false;

    mounted()
    {
		console.log('updating project data');
        this.readData();
        for(let node of (this as any).projectNodes)
        {
            if (node[1] != null)
            {
                let copy : Node = Object.assign({}, node[1]);
                copy.nodeid = node[0];
                copy.trackID = -1;
                this.writeMapNodes.push([node[0], copy]);
            }
		}
		this.$nextTick(()=>{
			this.hasLoaded = true;
		})
    }

    writeProjectData()
    {
        // TODO: Track if project data was written
        if (!deepEqual(this.projectData, JSON.parse(this.project.data)))
        {
			let data = new ChangeMapDataPacket;
			console.log(this.projectData);
			data.data = JSON.stringify(this.projectData);
            SendPacket(PacketType.ChangeMapData, data);
        }
	}
	
	canDeleteMapPin(pin : Node | null | undefined)
	{
		if (!pin) return true;

		let mtt = this.$store.state.project.mapToTimeline as Map<number, number[]>;
		if (mtt.has(pin.nodeid))
		{
			let list = mtt.get(pin.nodeid);
			if (!list) return true;
			if (list.length > 0)
			{
				return false;
			}
		}
		return true;
	}

    genPackets()
    {
        let created : MapNodeCreateRequest[] = [];
        let modified : MapNodeEditRequest[] = [];
        let remainIds : number[] = [];

        for (let kv of this.writeMapNodes)
        {
            let idx : number = kv[0];
            let node : Node = kv[1];
            console.log(`${idx}: ${node.name}, ${node.trackID == -1 ? 'Old' : 'New'}`);
            if (node.trackID == -1)
            {
                let og = this.projectNodes.get(idx);
                if (og == null)
                {
                    throw {message: "Failed to locate node for comparison"};
                }
                
                if (node.name != og.name || node.position.x != og.position.x || node.position.y != og.position.y)
                {
                    let req = new MapNodeEditRequest;
                    req.id = idx;
                    req.title = node.name;
                    req.position = node.position;
                    modified.push(req);
                }
            }
            else
            {
                console.log('creating node');
                let req = new MapNodeCreateRequest;
                req.title = node.name;
                req.position = node.position;
                created.push(req);
            }
            remainIds.push(idx);
        }

        /*
        // TODO: Binary search here instead of includes
        remainIds.sort((a,b)=>{
            return a-b;
        });*/
        
        let deleted : MapNodeDestroy[] = [];
        for(let kv of this.projectNodes)
        {
            let k = kv[0];
            if (!remainIds.includes(k))
            {
                let req = new MapNodeDestroy;
                req.id = k;
                deleted.push(req);
            }
        }

        return {created, modified, deleted};
    }

    save()
    {
        let packets = this.genPackets();
        console.log(packets);
        
        for(let create of packets.created)
        {
            SendPacket(PacketType.MapNodeCreate, create);
        }
        
        for(let modify of packets.modified)
        {
            SendPacket(PacketType.MapNodeEdit, modify);
        }

        for(let deleted of packets.deleted)
        {
            SendPacket(PacketType.MapNodeDestroy, deleted);
        }

		this.writeProjectData();
		this.$emit('saved');
    }

    readData()
    {
		console.log(this.project.data);
		let parsed = JSON.parse(this.project.data);
		//this.projectData.type = parsed.type;
		//Object.assign(this.projectData, parsed);
		this.$set(this, 'projectData', parsed)
    }

	get isInputValid() : boolean {
		console.log('checking validity');
		if (this.projectData.type == 'image')
		{
			if ((this.projectData as any).background_image == '') return false;
			if (!this.$refs.imageInputComponent) return false;
			if (!(this.$refs.imageInputComponent as any).imageURLValid) return false;
		}
		console.log('valid');
		return true;
	}

	mapOptions = [
		{value: 'default', text: 'Default World Map'},
		{value: 'image', text: 'Image (URL)'},
		{value: 'map', text: 'Map'},
		{value: 'none', text: 'None'}
	];
	
	emptyString = ''
	projectData = {type: 'default', data: null};
	projectName = ""
	projectDescription = ""

	writeMapNodes : any[][] = []
	selectedMapPin: Node = <any>null;

	imgMapClicked(x : number, y : number){
		let vec = new Vector2(x, this.projectData.type == 'map' ? y : 1-y);
		if (this.selectedMapPin)
		{
			this.$set(this.selectedMapPin, 'position', vec);
		}
		else
		{
			let n = new Node();
			n.position = vec
			n.name = "New Map Pin"
			
			// This is weird bc of the way that the getter works
			this.writeMapNodes.push([this.writeMapNodes.length, n]);
			this.$set(this, 'selectedMapPin', n)
		}
	}

	imgNodeClicked(node : Node){
		this.$set(this, 'selectedMapPin', node)
	}
	
	gooMapCenterChange(center : any){
		console.log(`${center.lat}, ${center.lng}`);
		(this.projectData as any).coords.latitude = center.lat;
		(this.projectData as any).coords.longitude = center.lng;
	}

	gooMapZoomChange(zoom : any){
		(this.projectData as any).coords.zoom_level = zoom;
	}

	deleteSelectedNode(){
		if (!this.selectedMapPin)
		{
			return;
		}

		for(let i = 0; i < this.writeMapNodes.length; ++i)
		{
			let cur = (this.writeMapNodes as any)[i][1];
			if (cur == this.selectedMapPin)
			{
				this.writeMapNodes.splice(i, 1);
				break;
			}
		}
		this.$set(this, 'selectedMapPin', null)
	}

	saveSelectedNode()
	{
		this.$set(this, 'selectedMapPin', null)
	}
}
